import React from 'react';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import IconSvg from '../../common/IconSvg';

export const ConnectPayPalContainer = styled.div`
  min-width: 197.6px;
  padding-right: 10px;
  height: 84.9px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  box-shadow: 0px 1px 7px 0 rgba(0, 105, 250, 0.32);
  background-color: #ffffff;
  margin-top: 32px;

  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
`;

export const CustomPayPalIcon = styled(IconSvg)`
  margin-top: 11.5px;
  margin-left: 7px;
`;

export const ConnectToPayPal = styled.span`
  width: 117px;
  height: 19px;
  object-fit: contain;
  font-family: Roboto;
  font-size: ${({ theme }) => theme.fontSize.medium};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.07;
  letter-spacing: 0px;
  text-align: left;
  color: #0070ba;
`;

export const PayPalCardSubtitle = () => (
  <span>
    <FormattedMessage id="onboarding.screen5.subtitle1" />,
    <br />
    <FormattedMessage id="onboarding.screen5.subtitle2" />
  </span>
);
